<icc-select-box
  [title]="selectedItem?.name"
  [description]="selectedItem?.description"
  [imageUrl]="selectedItemImg"
></icc-select-box>

@if (colors.length > 0) {
  <mat-card appearance="outlined" class="mat-elevation-2">
    <div>
      <p>{{ 'DOOR|Wybierz kolor:' | translate }}</p>
      <icc-list [items]="colors" itemTemplate="itemColor" [scrollable]="false" [selected]="selColor" (select)="selectColor($event)">
      </icc-list>
    </div>
  </mat-card>
}

<button type="button" mat-raised-button color="primary" (click)="save()">{{ 'INTERFACE|OK' | translate }}</button>
